import { justNumbers } from "helper/parser"
import { DateTime } from "luxon"

export function formatCurrency(value, minimumFractionDigits = 2) {

    const rawValue = justNumbers(value)

    if (typeof value !== 'string') {
        console.warn(value + ' param need to be string!')
    } else if (minimumFractionDigits !== 2 && minimumFractionDigits !== 3 && minimumFractionDigits !== 3) {
        console.warn('minimumFractionDigits param need to be 2|3|4!')
    }

    let num = 0

    switch (minimumFractionDigits) {
        case 2:
            num = Number(rawValue) / 100
            break
        case 3:
            num = Number(rawValue) / 1000
            break
        case 4:
            num = Number(rawValue) / 10000
            break
        default:
            num = 0
    }
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits })
}

export function formatCurrencyToDecimal(value) {
    const num = Number(justNumbers(value)) * 0.01
    return Number(num.toFixed(2))
}

export function formatIntegerToCurrency(value) {
    const num = Number(value)
    return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
export function formatIntegerToDecimal(value) {
    if (value == null) {
        return <b>NULL</b>
    }

    const num = Number(value)
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
}

export function formatDatetime(value) {
    if (value) {
        const dataLuxon = DateTime.fromISO(value)
        return dataLuxon.toFormat('dd/MM/yyyy HH:mm')
    }
    return null
}
export function toJSDate2(value) {
    return value ? new Date(value) : null
}
/**
 * Desconsidera o fuso se value for maior que 10 caracteres
 */
export function toJSDate(value) {
    if (!value) return null
    const [year, month, day] = value.substring(0, 10).split('-').map(Number)
    return new Date(year, month - 1, day)
}

export function toJSDatetime(value) {
    if (!value) return null
    return new Date(value)
}

export function showNull(value) {
    if (value == null) {
        return <b>NULL</b>
    }
    return value
}

export function getMask(name = "") {

    switch (name) {
        case 'cellphone': return '(99) 99999-999?9'
        case 'cpf': return '999.999.999-99'
        // CNPJ alfanumérico: 12 posições alfanuméricas + 2 dígitos verificadores numéricos
        // PrimeReact InputMask: 9 = numérico, a = alfabético, * = alfanumérico
        case 'cnpj': return '**.***.***/****-99'
        case 'cep': return '99.999-999'
        case 'datetime': return '99/99/9999 99:99'
        default: return ''
    }
}

export function boolToNumber(value, notNull) {

    if (notNull) {
        return value ? 1 : 0
    }

    if (value === null || value === undefined) return null
    return value ? 1 : 0
}

export function numberToBool(value) {

    if (value === 1 || value === true) return true
    if (value === 0 || value === false) return false

    return null

}

export function formatCellphone(telefone = '') {

    if (telefone) {

        telefone = telefone.replace(/\D/g, '')
        const nonoDigito = telefone.length > 10 ? '9' : ''
        return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3' + nonoDigito)
    }

    return telefone

}

export function formatCPF(cpf = '') {

    cpf = cpf.replace(/\D/g, '')
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')

}
export function formatCNPJ(cnpj = '') {

    cnpj = cnpj.replace(/\D/g, '')
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')

}

export function jsDateToLuxonString(value) {
    if (value) {
        const newOne = DateTime.fromJSDate(value).toString()
        if (newOne.includes('Invalid')) {
            console.error(`Error '${newOne}' trying to convert '${value}' to string Luxon, the date must be in JSDate format!`)
        }
        return newOne
    }
    return null
}

export function clearMili(e) {
    if (e) {
        return e.split('.')[0] + '.000+00:00'
    }
    return e
}

export function createCodeDescriptionObject(data, codeField, descriptionField, joinDescription, extraFields = [], altCodeValue, altDescriptionValue) {

    if (!data) data = { [codeField]: null, [descriptionField]: null }

    let extra = {}

    if (extraFields) {
        for (const element of extraFields) {

            if (element.includes('.')) {
                const div = element.split('.')
                extra[div[1]] = data[div[0]][div[1]]
            } else {
                extra[element] = data[element]
            }
        }
    }

    const codeValue = altCodeValue || data[codeField]
    const descriptionValue = altDescriptionValue || data[descriptionField]

    return {
        [codeField]: codeValue,
        [descriptionField]: joinDescription ? `${codeValue} - ${descriptionValue}` : descriptionValue,
        ...extra
    }

}

// form.getValues('usu_ins_prod') + ' - ' + registro?.meta?.nome_razao_usu_ins

export function cd({ code, description }) {

    let desc = ''

    if (code) desc += code
    if (description) {
        if (desc) desc += ' - '
        if (desc) desc += description
    }

    return desc

}

export class mountString {
    constructor() {
        const parts = []

        this.len = function () {
            return parts.length
        }

        this.add = function (ds, prefix = '', sufix = '') {

            if (!ds) return this

            if (ds === undefined || ds === null) return this

            const t = typeof ds

            if (typeof ds !== 'string') ds = String(ds)

            if (ds && ds?.trim() !== '') {
                parts.push(prefix + ds.trim() + sufix)
            }
            return this
        }

        this.addBool = function (logicalValue, stringIfTrue, stringIfFalse) {
            if (logicalValue === null || typeof logicalValue === 'undefined') {
                return this
            }

            if (logicalValue === true) {
                this.add(stringIfTrue)
            } else if (logicalValue === false && stringIfFalse) {
                this.add(stringIfFalse)
            }
            return this
        }

        this.addByIndex = function (key, keys, values) {
            if (key === null || typeof key === 'undefined' || !keys || !values) {
                return this
            }

            const index = keys.indexOf(key)

            if (index !== -1 && index < values.length) {
                this.add(values[index])
            }
            return this
        }

        this.addKeyless = function (sourceString, delimiter = '-') {
            if (!sourceString || typeof sourceString !== 'string' || !delimiter || typeof delimiter !== 'string') {
                return this
            }

            const partsArray = sourceString.split(delimiter)

            if (partsArray.length > 1) {
                this.add(partsArray[1].trim())
            }
            return this
        }

        // this.toString = function () {
        //     return parts.join(', ')
        // }

        this.toString = function () {
            const str = parts.join(', ')
            return {
                toString: () => str,
                capitalized: () => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(),
                [Symbol.toString]: () => str
            }
        }
    }
}
